<template>
  <NuxtLink :to="to ?? undefined" class="relative">
    <USkeleton v-if="!isLoaded" class="relative flex items-center justify-center w-full h-48 rounded-md overflow-hidden animate-none">
      <div class="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent
                via-white/40 dark:via-white/10 to-transparent" />
    </USkeleton>
    <img :src="src ? src: imageUrlDefault" :alt="alt ?? undefined" @load="isLoaded = true" @error="handleImageError"
          class="w-full h-48 object-cover rounded-t-xl" :class="$attrs.class" />

  <UBadge v-if="showBadgeInscricao" icon="ph:sign-in"
          :label="labelBadgeInscricao" size="md" color="primary" variant="outline"
          class="absolute top-3 right-3 z-10 bg-white backdrop-blur-md shadow-md font-bold uppercase"/>

  <UBadge v-if="aberto_para_visitante" icon="ph:eye"
          label="Aberto para Visitantes" size="md" color="success" variant="outline"
          class="absolute top-3 left-3 z-10 bg-white backdrop-blur-md shadow-md font-bold uppercase"/>
  </NuxtLink>
</template>

<script setup lang="ts">
defineOptions({
  inheritAttrs: false
})
// Estado reativo para controlar se a imagem já baixou
const isLoaded = ref(false);
const config = useRuntimeConfig()
const assetsPath = config.public.assetsPath

const imageUrlDefault = ref(assetsPath + '/img_categories/capa-fic-mais-ifmg.jpg');

const {
  src = undefined,
  to = undefined,
  alt = undefined,
  auto_inscricao = null,
  aberto_para_visitante = false,
} = defineProps<{
  src?: string;
  to?: string;
  alt?: string;
  showBadgeInscricao?: boolean | null;
  auto_inscricao?: "open" | "by_password" | null;
  aberto_para_visitante?: boolean;
}>();
const showBadgeInscricao = ref<boolean>(false);
const labelBadgeInscricao = ref<string>();

// Se a imagem falhar ao carregar (ex: link quebrado), você pode tratar aqui
const handleImageError = () => {
  isLoaded.value = true
}
onMounted(() => {
  showBadgeInscricao.value = auto_inscricao != null;

  if (auto_inscricao == 'open') {
    labelBadgeInscricao.value = "Autoinscrição";
  } else if (auto_inscricao == 'by_password') {
    labelBadgeInscricao.value = "Inscrição via Chave";
  }
})
</script>